<template>
  <div class="logo">
    <router-link :to="{name:'dashboard'}">
<!--      <LogoSvg alt="logo" />-->
<!--      此处更换为自己的logo-->
      <img src="logo.png" />
      <h1 v-if="showTitle" style="font-size:20px">{{ title }}</h1>
    </router-link>
  </div>
</template>

<script>
import LogoSvg from '@/assets/logo.svg?inline'

export default {
  name: 'Logo',
  components: {
    LogoSvg
  },
  props: {
    title: {
      type: String,
      default: '胜鑫管理平台',
      required: false
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  }
}
</script>
